<template>
  <v-card outlined>
    <v-card-title class="text_primary">
      {{ page_title }}

      <v-spacer></v-spacer>
    </v-card-title>

    <v-divider></v-divider>
    <v-row class="mt-1 mb-1 pr-3">
      <v-col cols="12" lg="8" md="12" xs="12">
        <v-card-text class="d-flex align-center justify-end pt-0 pr-0 pb-0">
          <v-text-field
            dense
            outlined
            v-model="search"
            label="搜尋 帳號名稱 / 電子郵件"
            single-line
            hide-details
            @keypress.enter="searchKeyword(search)"
          ></v-text-field>
          <v-btn
            @click="searchKeyword(search)"
            class="ml-3 btn_action btn_action_bg_linear"
          >
            <v-icon> mdi-magnify </v-icon>
          </v-btn>
        </v-card-text>
      </v-col>
      <v-col cols="12" lg="4" md="12" xs="12">
        <v-card-text class="d-flex align-center justify-end pa-0">
          <v-select
            label="顯示"
            style="max-width: 7em"
            outlined
            return-object
            @change="chagePerPage(selected_per_page)"
            v-model="selected_per_page"
            :items="per_page_items"
            item-value="value"
            item-text="name"
            hide-details
            dense
          >
          </v-select>
        </v-card-text>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-data-table
      :key="is_loading"
      sort-by="id"
      hide-default-footer
      :headers="headers"
      :items="datas"
      :items-per-page="selected_per_page.value"
      :loading="is_loading"
    >
      <template v-slot:[`item.role`]="{ item }">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-if="item.is_beta_user"
              color="#FFC107"
              v-bind="attrs"
              v-on="on"
            >
              mdi-shield-crown
            </v-icon>
          </template>
          <span>內部人員</span>
        </v-tooltip>

        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-if="item.is_partner_user"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              mdi-handshake
            </v-icon>
          </template>
          <span>合作夥伴</span>
        </v-tooltip>

        <v-tooltip right v-if="item.enable">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="success"
              v-bind="attrs"
              v-on="on"
            >
              mdi-account-check
            </v-icon>
          </template>
          <span>帳號已啟用</span>
        </v-tooltip>

        <v-tooltip right v-if="!item.enable">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="grey"
              v-bind="attrs"
              v-on="on"
            >
              mdi-account-off
            </v-icon>
          </template>
          <span>帳號未啟用</span>
        </v-tooltip>

      </template>

      <template v-slot:[`item.created_at`]="{ item }">
        <span>{{ $utils.formatTime(item.created_at, "-") }}</span>
      </template>

      <template v-slot:[`item.actions`]="{ item }">

        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="#000000">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              @click="help(item)"
            >
              <v-list-item-title>代客操作</v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="item.enable === false"
              @click="enable(item, true)"
            >
              <v-list-item-title>啟用帳號</v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="item.enable === true"
              @click="enable(item, false)"
            >
              <v-list-item-title>停用帳號</v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="item.is_beta_user === false"
              @click="updateRole(item, true, 'betaUser')"
            >
              <v-list-item-title>開啟內部權限</v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="item.is_beta_user === true"
              @click="updateRole(item, false, 'betaUser')"
            >
              <v-list-item-title>移除內部權限</v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="item.is_partner_user === false"
              @click="updateRole(item, true, 'partnerUser')"
            >
              <v-list-item-title>設為夥伴</v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="item.is_partner_user === true"
              @click="updateRole(item, false, 'partnerUser')"
            >
              <v-list-item-title>移除夥伴</v-list-item-title>
            </v-list-item>

            <v-list-item
              @click="editContainer(item)"
            >
              <v-list-item-title>編輯顯示容器</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

    <div class="text-center mt-5">
      <Pagination v-if="page_setting.is_show" :setting="page_setting" />
    </div>

    <v-dialog 
      v-if="tree_dialog.is_show" 
      v-model="tree_dialog.is_show"
      width="900"
      @click:outside="tree_dialog.is_show = false"
    >
      <v-card>
          <v-card-title 
            class="text-h5 white--text"
            style="background-color:#5087e6;"
          >
            打勾是看的到的容器
          </v-card-title>

          <v-card-text
            class="pl-5 pr-5 mt-6 mb-3 pb-0"
            style="max-height:300px;overflow-y:scroll;"
          >
            <div v-for="org_item in tree_dialog.items" :key="org_item.id">
              <v-switch
                v-model="org_item.enabled"
                :label="`${org_item.name} ${org_item.enabled ? '(全開)': ''}`"
                class="mb-2"
                hide-details
                dense
                @change="onGroupSwitchChange(org_item)"
              />
          
              <v-checkbox
                v-for="item in org_item.children"
                :key="item.id"
                :label="item.name"
                :value="item.enabled"
                v-model="item.enabled"
                :disabled="org_item.enabled"
                hide-details
                dense
              />
            </div>

          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="grey"
                text
                @click="tree_dialog.is_show = false"
            >
              關閉
            </v-btn>
            <v-btn
                :color="'info'"
                text
                @click="saveShowContainer"
            >
                保存
            </v-btn>
          </v-card-actions>
      </v-card>

    </v-dialog>
  </v-card>
</template>
<script>
import {
  apiGetUserList,
  apiEnableUser,
  apiImpersonateUser,
  apiAddRole,
  apiRemoveRole,
  apiGetUserInfo,
  apiAssignUserContainer,
  apiSwitchUserContainerRoleEnable
} from "@/api/user.js";

import { apiGetOrgContainer } from "@/api/admin.js";

import Pagination from "@/components/Utils/Pagination.vue";
export default {
  name: "ClientList",
  components: {
    Pagination,
  },
  data: function () {
    return {
      search: "",
      page_title: "用戶",
      is_loading: false,
      datas: [],
      headers: [
        {
          text: "",
          sortable: false,
          value: "role",
          align: "center",
        },
        {
          text: "帳號名稱",
          sortable: false,
          value: "user_name",
        },
        {
          text: "電子郵件",
          sortable: false,
          value: "email",
        },
        {
          text: "註冊時間",
          sortable: false,
          value: "created_at",
        },
        {
          text: "",
          sortable: false,
          value: "actions",
          align: "right",
        },
      ],
      page_setting: {
        is_show: false,
        selected_page: 1,
        total_page: 10,
        total_visible: 10,
      },
      selected_per_page: {
        name: "10筆",
        value: 10,
      },
      per_page_items: [
        {
          name: "10筆",
          value: 10,
        },
        {
          name: "24筆",
          value: 24,
        },
        {
          name: "48筆",
          value: 48,
        },
        {
          name: "100筆",
          value: 100,
        },
      ],
      tree_dialog: {
        is_show: false,
        items: []
      },
    };
  },
  mounted: async function () {
    this.initData();
  },
  methods: {
    initData: async function () {
      this.is_loading = true;
      // 先抓網址上的頁碼，沒有預設就帶1
      let page_idx = parseInt(this.$route.query.page)
        ? parseInt(this.$route.query.page)
        : 1;
      let limit = parseInt(this.$route.query.limit)
        ? parseInt(this.$route.query.limit)
        : this.selected_per_page.value;
      this.search = this.$route.query.keyword ? this.$route.query.keyword : "";
      console.log("page_idx", page_idx);
      console.log("limit", limit);
      if (isNaN(limit)) {
        limit = 10;
      }

      if (isNaN(page_idx)) {
        page_idx = 1;
      }
      try {
        let data = await apiGetUserList(
          page_idx,
          limit,
          this.search,
          "created_at"
        );
        console.log("回應", data);
        if (data === null) {
          return;
        }

        this.page_setting = {
          is_show: true,
          selected_page: page_idx,
          total_page: data.totalPages,
          total_visible: 10,
        };
        this.selected_per_page = {
          name: `${limit}筆`,
          value: limit,
        };
        console.log("this.page_setting", this.page_setting);
        this.datas = data.content.sort((a, b) => a.id - b.id);
      } catch (error) {
        let message = "";
        if (error.response) {
          message = error.response.data.msg;
        } else {
          message = error;
        }
        this.$root.vtoast.show({
          message: message,
        });
      }
      this.is_loading = false;
    },
    chagePerPage: function (selected_per_page) {
      let query = this.$route.query;
      let tmp_query = { ...query, limit: selected_per_page.value, page: 1 };
      console.log(tmp_query);
      try {
        this.$router.push({ path: this.$route.path, query: tmp_query });
      } catch (err) {
        if (err.name !== "NavigationDuplicated") {
          throw err;
        }
      }
    },
    async enable(item, is_enable) {
      let params = {
        email: item.email,
        enable: is_enable,
      };

      try {
        let result = await apiEnableUser(params);
        console.log("result", result);
        let status = "啟用";
        if (is_enable === false) {
          status = "停用";
        }
        this.$root.vtoast.show({
          color: "primary",
          message: `${status}成功`,
        });
        await this.initData();
      } catch (error) {
        this.$root.vtoast.show({
          message:
            `更新啟用狀態失敗: ` +
            (error.response ? JSON.stringify(error) : error),
        });
      }
    },
    async help(item) {
      console.log(item);
      let user_id = item.id;
      try {
        let params = {
          user_id: user_id,
        };
        let result = await apiImpersonateUser(params);
        console.log(result);
        let token = result.data.token;
        let url = new URL(
          `${process.env.VUE_APP_USER_PLATFORM_URL}/user_impersonate`
        );
        console.log(url.href);
        url.searchParams.append("access_token", token);
        window.open(url.href, "_blank");
      } catch (error) {
        let message = "取得使用者Token失敗，原因: ";
        if (error.response) {
          message += error.response.data.msg;
        } else {
          message += error;
        }
        this.$root.vtoast.show({
          message: message,
        });
      }
    },
    async searchKeyword(keyword) {
      console.log("keyword:", keyword);
      let query = this.$route.query;
      let tmp_query = {
        ...query,
        limit: this.selected_per_page.value,
        page: 1,
        keyword: keyword,
      };
      console.log(tmp_query);
      try {
        this.$router.push({ path: this.$route.path, query: tmp_query });
      } catch (err) {
        console.log("ex");
        console.log("err.name", err.name);
        if (err.name !== "NavigationDuplicated") {
          throw err;
        }
      }
    },
    async updateRole(item, is_beta_user, role_name) {
      console.log("item", item);
      console.log("is_beta_user", is_beta_user);

      let result = null;
      let params = {
        user_id: [item.id],
        target_role: role_name
      };
      if (is_beta_user) {
        let is_confirm = confirm(`是否要調整為${role_name}?`);
        if (!is_confirm) {
          return;
        }
        try {
          result = await apiAddRole(params);
        } catch (error) {
          this.$root.vtoast.show({
            message: error,
          });
        }
      } else {
        let is_confirm = confirm(`是否移除${role_name}權限?`);
        if (!is_confirm) {
          return;
        }
        try {
          let ids = [item.id];
          ids = ids.join(",");
          result = await apiRemoveRole(role_name, ids);
        } catch (error) {
          this.$root.vtoast.show({
            message: error,
          });
        }
      }

      if (result){
        this.$root.vtoast.show({
          message: "更新成功",
          color: "primary",
        });
      }

      console.log("result", result);
      this.initData();
    },
    async editContainer(item){
      console.log('item', item)
      let organizations = []
      let container_user_enabled = {}
      let selected_container = []
      try {
        let result = await apiGetUserInfo(item.id)
        console.log('result', result)
        organizations = result.organizations
        selected_container = result.container_user_enabled.container.map(container => {
          return container.id
        })
        container_user_enabled = result.container_user_enabled
      } catch (error) {
        console.log('error', error)
      }

      console.log('selected_container',selected_container)

      let container_mapper = {}
      for (let idx = 0;idx < organizations.length; idx++) {
        let organization = organizations[idx]
        if (!container_mapper[organization.org_id]) {
          container_mapper[organization.org_id] = {}
          container_mapper[organization.org_id].name = organization.org_name
          container_mapper[organization.org_id].containers = []
        }

        let result = await apiGetOrgContainer(organization.org_id)
        console.log('result',result)
        container_mapper[organization.org_id].containers = result
      }

      console.log('container_mapper',container_mapper)

      let container_trees = []
      Object.keys(container_mapper).forEach(org_id => {
        let is_container_user = container_user_enabled.enabled_status.find(status => {
          return status.enable === true && status.userAuthId.orgId === org_id
        })

        let item = {
          id:org_id,
          name: container_mapper[org_id].name,
          children: container_mapper[org_id].containers,
          enabled: !is_container_user 
        }
        container_trees.push(item)


        container_mapper[org_id].containers.forEach(container => {
          if (!is_container_user) {
            container.enabled = true
          }
          else {
            if (selected_container.includes(container.id)) {
              container.enabled = true
            }
          }
          
        })

      })

      console.log('container_trees',container_trees)
      this.tree_dialog.items = container_trees
      this.tree_dialog.user_id = item.id
      this.tree_dialog.is_show = true 
    },
    onGroupSwitchChange(group) {
      console.log('group', group)
      group.children.forEach(container => {
        container.enabled = true
      })
    },
    async saveShowContainer(){
      console.log(this.tree_dialog.items)
      let show_containers = []
      this.tree_dialog.items.forEach(org_item => {
        if (!org_item.enabled) {
          org_item.children.forEach(container => {
            if (container.enabled) {
              show_containers.push(container.id)
            }
          })
        }
      })

      let params = {
        user_id: this.tree_dialog.user_id,
        container_id: show_containers
      }

      console.log('params', params)

      try {
        let result = await apiAssignUserContainer(params)
        console.log('result', result)
        this.$root.vtoast.show({
          message: '更新成功!',
        });
      } catch (error) {
        console.log('error', error)
        this.$root.vtoast.show({
          message: `更新失敗，原因: ${error}`,
        });
      }
      // 打role
      try {
        let params = {
          user_id: this.tree_dialog.user_id,
          org:[]
        }
        for (let idx = 0; idx < this.tree_dialog.items.length; idx++) {
            params.org.push({
              "org_id": this.tree_dialog.items[idx].id,
              "enable": !this.tree_dialog.items[idx].enabled
            })
        }
        let result = await apiSwitchUserContainerRoleEnable(params)
        console.log('update_role', result)
      } catch (error) {
        console.log('error', error)
        this.$root.vtoast.show({
          message: `更新role失敗，原因: ${error}`,
        });
      }

      this.tree_dialog.is_show = false

    }
  },
  computed: {},
};
</script>
<style scoped></style>
